export default __webpack_public_path__ + "static/media/1.313a27d8.png";